const LOCAL_STORE_INFO = 'LOCAL_STORE_INFO_155'; // 155 有更新缓存
const SESSION_LOGIN_ERR_TIMES = 'SESSION_LOGIN_ERR_TIMES';

// 初始化时候从localStorage获取登录信息
export const getLoginInfo = () => {
    try {
        return JSON.parse(localStorage.getItem(LOCAL_STORE_INFO) || '{}');
    } catch (err) {
        return {};
    }
};

export const setLoginInfo = (info) => {
    localStorage.setItem(LOCAL_STORE_INFO, JSON.stringify(info || {}));
};

export const deleteLoginInfo = () => {
    localStorage.removeItem(LOCAL_STORE_INFO);
};

const resolveAppInfo = (cb) => {
    const localInfo = getLoginInfo();

    cb(localInfo);
};

export const setLoginErrTimes = () => {
    const timeNow = (new Date()).getTime();
    try {
        const errInfo = JSON.parse(sessionStorage.getItem(SESSION_LOGIN_ERR_TIMES) || '{}');
        if (errInfo.t && timeNow - errInfo.t < 10 * 60 * 1000) {
            sessionStorage.setItem(SESSION_LOGIN_ERR_TIMES, JSON.stringify({
                t: errInfo.t,
                errTimes: errInfo.errTimes ? errInfo.errTimes + 1 : 1,
            }));
            if (errInfo.errTimes && errInfo.errTimes + 1 >= 3) {
                return true;
            }
            return false;
        }
        sessionStorage.setItem(SESSION_LOGIN_ERR_TIMES, JSON.stringify({
            t: timeNow,
            errTimes: 1,
        }));
        return false;
    } catch (err) {
        sessionStorage.setItem(SESSION_LOGIN_ERR_TIMES, JSON.stringify({
            t: timeNow,
            errTimes: 1,
        }));
        return false;
    }
};

export const clearLoginErrTimes = () => {
    sessionStorage.removeItem(SESSION_LOGIN_ERR_TIMES);
};

export default resolveAppInfo;



// WEBPACK FOOTER //
// ./src/utils/loginInfo.js